import { render, staticRenderFns } from "./reduce-dialog.vue?vue&type=template&id=43ef0c02&scoped=true&"
import script from "./reduce-dialog.vue?vue&type=script&lang=js&"
export * from "./reduce-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef0c02",
  null
  
)

export default component.exports